import {
  createConfig,
  walkNode
} from '@/components/common/controlBar/controlBarDialog/metaComponent/utils.js'
import elements from '@/components/widgets/list_news_index/element.js'

const getController = async (componentName, _type) => {
  try {
    var module
    if (componentName === 'index_case_style2') {
      module = await import(`./components/widgets/index_case/style2/controller.js`)
    } else if (componentName === 'related_carousel_product_style5') {
      module = await import(`./components/widgets/related_carousel_product/style5/controller.js`)
    } else if (componentName === 'related_carousel_product_style8') {
      module = await import(`./components/widgets/related_carousel_product/style8/controller.js`)
    } else if (componentName === 'related_carousel_product_style7') {
      module = await import(`./components/widgets/related_carousel_product/style7/controller.js`)
    } else if (componentName === 'product_home_list') {
      module = await import(`./components/widgets/product_home_list/style3/controller.js`)
    } else if (componentName === 'product_home_list_style2') {
      module = await import(`./components/widgets/product_home_list/style2/controller.js`)
    } else if (componentName === 'product_home_list_style4') {
      module = await import(`./components/widgets/product_home_list/style4/controller.js`)
    } else if (componentName === 'product_home_list_style5') {
      module = await import(`./components/widgets/product_home_list/style5/controller.js`)
    } else if (componentName === 'product_home_list_style1') {
      module = await import(`./components/widgets/product_home_list/style1/controller.js`)
    } else if (componentName === 'product_home_list_style6') {
      module = await import(`./components/widgets/product_home_list/style6/controller.js`)
    } else if (componentName === 'product_home_list_style7') {
      module = await import(`./components/widgets/product_home_list/style7/controller.js`)
    } else if (componentName === 'product_category_style3') {
      module = await import(`./components/widgets/product_category/style3/controller.js`)
    } else if (componentName === 'product_category_style1') {
      module = await import(`./components/widgets/product_category/style1/controller.js`)
    } else if (componentName === 'product_category_style2') {
      module = await import(`./components/widgets/product_category/style2/controller.js`)
    } else if (componentName === 'product_category_style5') {
      module = await import(`./components/widgets/product_category/style5/controller.js`)
    } else if (componentName === 'product_category_style4') {
      module = await import(`./components/widgets/product_category/style4/controller.js`)
    } else if(componentName === 'product_category_style6'){
      module = await import(`./components/widgets/product_category/style6/controller.js`)
    } else if (componentName === 'related_carousel_new_news_style1') {
      module = await import(`./components/widgets/related_carousel_new_news/style1/controller.js`)
    } else if (componentName === 'related_carousel_new_news_style2') {
      module = await import(`./components/widgets/related_carousel_new_news/style2/controller.js`)
    } else if (componentName === 'related_carousel_new_news_style3') {
      module = await import(`./components/widgets/related_carousel_new_news/style3/controller.js`)
    } else if (componentName === 'related_carousel_new_news_style4') {
      module = await import(`./components/widgets/related_carousel_new_news/style4/controller.js`)
    } else if (componentName === 'related_carousel_new_case_style3') {
      module = await import(`./components/widgets/related_carousel_new_case/style3/controller.js`)
    } else if (componentName === 'related_carousel_new_case_style4') {
      module = await import(`./components/widgets/related_carousel_new_case/style4/controller.js`)
    } else if (componentName === 'list_news_style1') {
      module = await import(`./components/widgets/list_news/style1/controller.js`)
    } else if (componentName === 'list_news_style8') {
      module = await import(`./components/widgets/list_news/style8/controller.js`)
    } else if (componentName === 'index_case_style1') {
      module = await import(`./components/widgets/index_case/style1/controller.js`)
    } else if (componentName === 'index_case_style2') {
      module = await import(`./components/widgets/index_case/style2/controller.js`)
    } else if (componentName === 'image_text_tab_style1') {
      module = await import(`./components/widgets/image_text_tab/style1/controller.js`)
    } else if (componentName === 'image_text_tab_style2') {
      module = await import(`./components/widgets/image_text_tab/style2/controller.js`)
    } else if (componentName === 'image_text_tab_style3') {
      module = await import(`./components/widgets/image_text_tab/style3/controller.js`)
    } else if (componentName === 'image_text_tab_style4') {
      module = await import(`./components/widgets/image_text_tab/style4/controller.js`)
    } else if (componentName === 'advantage_process_style1') {
      module = await import(`./components/widgets/advantage_process/style1/controller.js`)
    } else if (componentName === 'scroll_text_style1') {
      module = await import(`./components/widgets/scroll_text/style1/controller.js`)
    } else if (componentName === 'home_product_list_style1') {
      module = await import(`./components/widgets/home_product_list_widget/style1/controller.js`)
    } else if (componentName === 'home_product_list_style2') {
      module = await import(`./components/widgets/home_product_list_widget/style2/controller.js`)
    } else if (componentName === 'nav' && _type === 'nav_top_style12') {
      module = await import(`./components/widgets/nav/style12/controller.js`)
    } else if (componentName === 'home_image_text_list_style1') {
      module = await import(`./components/widgets/home_image_text_list/style1/controller.js`)
    } else if (componentName === 'list_cert5') {
      module = await import(`./components/widgets/list_cert/style5/controller.js`)
    } else if(componentName === 'development_history_style3'){
      module = await import(`./components/widgets/development_history/style3/controller.js`)
    }  else if (componentName === 'development_history_2') {
      module = await import('@/components/widgets/development_history/style2/controller.js')
    } else if (componentName === 'index_case_10') {
      module = await import('@/components/widgets/index_case/style10/controller.js')
    } else if (componentName === 'fixed_point_style1') {
      module = await import(`./components/widgets/fixed_point/style1/controller.js`)
    } else if (componentName === 'fixed_point_animal_style1') {
      module = await import(`./components/widgets/fixed_point_animal/style1/controller.js`)
    } else if (componentName === 'head_mobile_style1') {
      module = await import(`./components/widgets/head_mobile/style1/controller.js`)
    } else if (componentName === 'head_mobile_style2') {
      module = await import(`./components/widgets/head_mobile/style2/controller.js`)
    } else if (componentName === 'index_case_style3') {
      module = await import(`./components/widgets/index_case/style3/controller.js`)
    } else if (componentName === 'list_news7') {
      module = await import(`./components/widgets/list_news/style7/controller.js`)
    } else if (componentName === 'development_history_style1') {
      module = await import(`./components/widgets/development_history/style1/controller.js`)
    } else if (componentName === 'svg_widget_style1') {
      module = await import(`./components/widgets/svg_widget/style1/controller.js`)
    } else if (componentName === 'content') {
      module = await import(`./components/module/content/controller.js`)
    } else if (componentName === 'foot') {
      module = await import(`./components/module/foot/controller.js`)
    } else if (componentName === 'head') {
      module = await import(`./components/module/head/controller.js`)
    } else if (componentName === 'module') {
      module = await import(`./components/module/module/controller.js`)
    } else if (componentName === 'three_five_slider') {
      module = await import(`./components/widgets/three_five_slider/controller.js`)
    } else if (componentName === 'development_history_style4') {
      module = await import(`./components/widgets/development_history/style4/controller.js`)
    } else if (componentName === 'accordion_style1') {
      module = await import(`./components/widgets/accordion/controller.js`)
    } else if (componentName === 'list_product_style14') {
      module = await import(`./components/widgets/list_product/style14/controller.js`)
    } else {
      module = await import(`./components/widgets/${componentName}/controller.js`)
    }
    window.controllers[componentName] = module.createControlller
    return module
  } catch (error) {
    console.error(`没有找到${componentName}的controller.js=====`, error)

    window.controllers[componentName] = function () {
      const controller = {
        attribute: {
          isShowGroup: false,
          metaComponentList: []
        },
        design: {
          isShowGroup: false,
          metaComponentList: []
        }
      }
      return controller
    }
  }
}
const getVue = async (componentName) => {
  try {
    var module
    if (componentName === 'index_case_style2') {
      module = await import(`./components/widgets/index_case/style2/index.vue`)
    } else if (componentName === 'list_download_home') {
      module = await import(`./components/widgets/list_download_home/style1/index.vue`)
    } else if (componentName === 'related_carousel_product_style5') {
      module = await import(`./components/widgets/related_carousel_product/style5/index.vue`)
    } else if (componentName === 'related_carousel_product_style8') {
      module = await import(`./components/widgets/related_carousel_product/style8/index.vue`)
    } else if (componentName === 'related_carousel_product_style7') {
      module = await import(`./components/widgets/related_carousel_product/style7/index.vue`)
    } else if (componentName === 'product_home_list') {
      module = await import(`./components/widgets/product_home_list/style3/index.vue`)
    } else if (componentName === 'product_home_list_style2') {
      module = await import(`./components/widgets/product_home_list/style2/index.vue`)
    } else if (componentName === 'product_home_list_style4') {
      module = await import(`./components/widgets/product_home_list/style4/index.vue`)
    } else if (componentName === 'product_home_list_style5') {
      module = await import(`./components/widgets/product_home_list/style5/index.vue`)
    } else if (componentName === 'product_home_list_style1') {
      module = await import(`./components/widgets/product_home_list/style1/index.vue`)
    } else if (componentName === 'product_home_list_style6') {
      module = await import(`./components/widgets/product_home_list/style6/index.vue`)
    } else if (componentName === 'product_home_list_style7') {
      module = await import(`./components/widgets/product_home_list/style7/index.vue`)
    } else if (componentName === 'product_category_style3') {
      module = await import(`./components/widgets/product_category/style3/index.vue`)
    } else if (componentName === 'product_category_style1') {
      module = await import(`./components/widgets/product_category/style1/index.vue`)
    } else if (componentName === 'product_category_style2') {
      module = await import(`./components/widgets/product_category/style2/index.vue`)
    } else if (componentName === 'product_category_style5') {
      module = await import(`./components/widgets/product_category/style5/index.vue`)
    } else if (componentName === 'product_category_style4') {
      module = await import(`./components/widgets/product_category/style4/index.vue`)
    } else if (componentName === 'product_category_style6'){
      module = await import(`./components/widgets/product_category/style6/index.vue`)
    } else if (componentName === 'related_carousel_new_news_style1') {
      module = await import(`./components/widgets/related_carousel_new_news/style1/index.vue`)
    } else if (componentName === 'related_carousel_new_news_style2') {
      module = await import(`./components/widgets/related_carousel_new_news/style2/index.vue`)
    } else if (componentName === 'related_carousel_new_news_style3') {
      module = await import(`./components/widgets/related_carousel_new_news/style3/index.vue`)
    } else if (componentName === 'related_carousel_new_news_style4') {
      module = await import(`./components/widgets/related_carousel_new_news/style4/index.vue`)
    } else if (componentName === 'related_carousel_new_case_style3') {
      module = await import(`./components/widgets/related_carousel_new_case/style3/index.vue`)
    } else if (componentName === 'related_carousel_new_case_style4') {
      module = await import(`./components/widgets/related_carousel_new_case/style4/index.vue`)
    } else if (componentName === 'list_news_style1') {
      module = await import(`./components/widgets/list_news/style1/index.vue`)
    } else if (componentName === 'list_news_style8') {
      module = await import(`./components/widgets/list_news/style8/index.vue`)
    } else if (componentName === 'index_case_style1') {
      module = await import(`./components/widgets/index_case/style1/index.vue`)
    } else if (componentName === 'index_case_style2') {
      module = await import(`./components/widgets/index_case/style2/index.vue`)
    } else if (componentName === 'image_text_tab_style1') {
      module = await import(`./components/widgets/image_text_tab/style1/index.vue`)
    } else if (componentName === 'image_text_tab_style2') {
      module = await import(`./components/widgets/image_text_tab/style2/index.vue`)
    } else if (componentName === 'image_text_tab_style3') {
      module = await import(`./components/widgets/image_text_tab/style3/index.vue`)
    } else if (componentName === 'image_text_tab_style4') {
      module = await import(`./components/widgets/image_text_tab/style4/index.vue`)
    } else if (componentName === 'advantage_process_style1') {
      module = await import(`./components/widgets/advantage_process/style1/index.vue`)
    } else if (componentName === 'scroll_text_style1') {
      module = await import(`./components/widgets/scroll_text/style1/index.vue`)
    } else if (componentName === 'home_product_list_style1') {
      module = await import(`./components/widgets/home_product_list_widget/style1/index.vue`)
    } else if (componentName === 'home_product_list_style2') {
      module = await import(`./components/widgets/home_product_list_widget/style2/index.vue`)
    } else if (componentName === 'home_image_text_list_style1') {
      module = await import(`./components/widgets/home_image_text_list/style1/index.vue`)
    } else if (componentName === 'list_cert5') {
      module = await import(`./components/widgets/list_cert/style5/index.vue`)
    } else if(componentName === 'development_history_style3'){
      module = await import(`./components/widgets/development_history/style3/index.vue`)
    } else if (componentName === 'fixed_point_style1') {
      module = await import(`./components/widgets/fixed_point/style1/index.vue`)
    } else if (componentName === 'fixed_point_animal_style1') {
      module = await import(`./components/widgets/fixed_point_animal/style1/index.vue`)
    } else if (componentName === 'head_mobile_style1') {
      module = await import(`./components/widgets/head_mobile/style1/index.vue`)
    } else if (componentName === 'head_mobile_style2') {
      module = await import(`./components/widgets/head_mobile/style2/index.vue`)
    } else if (componentName === 'index_case_style3') {
      module = await import(`./components/widgets/index_case/style3/index.vue`)
    } else if (componentName === 'list_news7') {
      module = await import(`./components/widgets/list_news/style7/index.vue`)
    } else if (componentName === 'development_history_style1') {
      module = await import(`./components/widgets/development_history/style1/index.vue`)
    } else if (componentName === 'svg_widget_style1') {
      module = await import(`./components/widgets/svg_widget/style1/index.vue`)
    } else if (componentName === 'content') {
      module = await import(`./components/module/content/index.vue`)
    } else if (componentName === 'foot') {
      module = await import(`./components/module/foot/index.vue`)
    } else if (componentName === 'head') {
      module = await import(`./components/module/head/index.vue`)
    } else if (componentName === 'module') {
      module = await import(`./components/module/module/index.vue`)
    } else if (componentName === 'development_history_2') {
      module = await import('@/components/widgets/development_history/style2/index.vue')
    } else if (componentName === 'index_case_10') {
      module = await import('@/components/widgets/index_case/style10/index.vue')
    } else if (componentName === 'three_five_slider') {
      module = await import(`./components/widgets/three_five_slider/index.vue`)
    } else if (componentName === 'development_history_style4') {
      module = await import(`./components/widgets/development_history/style4/index.vue`)
    } else if (componentName === 'accordion_style1') {
      module = await import(`./components/widgets/accordion/index.vue`)
    } else if (componentName === 'list_product_style14') {
      module = await import(`./components/widgets/list_product/style14/index.vue`)
    } else {
      module = await import(`./components/widgets/${componentName}/index.vue`)
    }

    window.componentMap[componentName] = module.default
    return module
  } catch (error) {
    console.error(`没有找到${componentName}的index.vue=====`, error)

    function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
      return (
        _openBlock(),
        _createBlock(
          $setup['viewCommon'],
          {
            ref: 'view',
            type: 'module',
            name: $props.data.name,
            data: $props.data,
            class: _normalizeClass([$setup.elements.self])
          },
          { default: _withCtx(() => [_renderSlot(_ctx.$slots, 'default')]), _: 3 /* FORWARDED */ },
          8 /* PROPS */,
          ['name', 'data', 'class']
        )
      )
    }

    window.componentMap[componentName] = {
      __name: 'index',
      props: {
        node: {
          required: false
        },
        data: {
          required: false
        }
      },
      _sfc_render: _sfc_render
    }
  }
}

function loadNodeSource(componentName, _type) {
  return new Promise((resolve) => {
    getController(componentName, _type).then((module) => {
      getVue(componentName).then((module) => {
        resolve()
      })
    })
  })
}

export function batchLoadNodesSource(nodeTree) {
  var arr = []
  walkNode(nodeTree, (walkedNode) => {
    arr.push(walkedNode)
  })
  arr.push({
    componentName: 'rowCol2'
  })
  arr.push({
    componentName: 'module'
  })
  arr.push({
    componentName: 'col'
  })
  arr.push({
    componentName: 'popagation'
  })
  arr.push({
    componentName: 'list_v2'
  })
  arr.push({
    componentName: 'tab'
  })
  arr.push({
    componentName: 'list_item'
  })
  arr.push({
    componentName: 'checkbox'
  })
  arr.push({
    componentName: 'svg'
  })
  arr.push({
    componentName: 'icon'
  })
  arr.push({
    componentName: 'image_image2'
  })
  arr.push({
    componentName: 'button_text_icon'
  })
  arr.push({
    componentName: 'slider'
  })
  arr.push({
    componentName: 'button_text'
  })
  arr.push({
    componentName: "text_title"
  })
  arr.push({
    componentName: "text_paragraph"
  })

  return new Promise((resolve) => {
    Promise.all(
      arr.map((node) => {
        return loadNodeSource(node.componentName, node._type)
      })
    ).then(() => {
      resolve()
    })
  })
}
